// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"test_notice-module_wrapper_93d3a","header":"test_notice-module_header_06a14","paragraph":"test_notice-module_paragraph_ceea7","link":"test_notice-module_link_f0256"};